const state = {
  users: [
      // {
      //   id: 0,
      //   name: 'none',
      //   role: 'none',
      //   isLeader: false,
      //   plot: []
      // }
  ],
  plotList: []
}

const getters = {
  users: state => state.users,
  count: state => state.count,
  getUserById: () => (id) => {
    console.log(id)
    console.log(state.users)
    console.log(state.users.find(user => user.id == id))
    return state.users.find(user => user.id == id)
  },
  getUsersByIds: (state, getters) => (ids) => {
    var foundUsers = []
    for (var idx in ids){
      foundUsers.push(getters.getUserById(ids[idx]))
    }
    return foundUsers
  },
  leader: state => {
    var leader = {}
    for (var i in state.users){
      if (state.users[i].isLeader){
        leader = state.users[i]
      }
    }
    return leader
  },
}

const actions = {
  addUser({ commit }) {
    commit('addUser')
  },
  addUsers({ commit }) {
    commit('addUsers')
  },
  setUsers({ commit }) {
    commit('setUsers')
  },
  setLeader({ commit }) {
    commit('setLeader')
  },
  setPlots({ commit }) {
    commit('setPlots')
  },
  clearUserList({ commit }) {
    commit('clearUserList')
  }
}

const mutations = {
  addUser(state, payload) {
    // payload.role = convertRoleJapanese(payload.role)
    state.users.push(payload);
  },
  addUsers(state, payload) {
    for ( var i in payload ) {
      // payload[i].role = convertRoleJapanese(payload[i].role)
      state.users.push(payload[i]);
    }
  },
  setUsers(state, payload) {
    console.log(payload)
    state.users = []
    var user = {}
    for ( var i in payload ) {
      user = payload[i]
      if (user.userName) {
        user.name = user.userName
        delete user.userName
      }
      if (user.userId) {
        user.id = user.userId
        delete user.userId
      }
      user.plots = []
      // if (payload[i].role) {
      //   user.role = convertRoleJapanese(payload[i].role)
      // }
      state.users.push(user);
      user = {}
    }
    console.log(state.users)
  },
  setLeader(state, payload) {
    console.log(payload)
    var user = {}
    for (var i in state.users){
      user = state.users[i]
      console.log(user.id == payload.userId)
      if (user.id == payload.userId){
        user.isLeader = true
        // state.users[i].isLeader = true
      }else {
        // state.users[i].isLeader = false
        user.isLeader = false
      }
      state.users.splice(i, 1, user)
      console.log(user)
    }
    console.log(state.users)
  },
  setPlots(state, payload) {
    console.log(payload)
    for (var assigned of payload) {
      state.users.filter(function(item){
        if (item.id == assigned.userId) return true;
      })[0].plots.push({'id':assigned.plotId, 'done':false})
      console.log(state.users.filter(function(item){if (item.id == assigned.userId) return true;})[0].plots)
      // plotListも更新
      state.plotList.push({'index': state.plotList.length, 'plotId': assigned.plotId, 'userId': assigned.userId})
    }

  },
  addPlot(state, payload) {
    for (var i in state.users){
      if (state.users[i].id == payload.userId){
        state.users[i].plots.push({'id':payload.plotId, 'done':false})
      }
    }
    // plotListも更新
    state.plotList.push({'index': state.plotList.length, 'plotId': payload.plotId, 'userId': payload.userId})
  },
  deletePlot(state, payload) {
    for (var user of state.users){
      if (user.id == payload.userId){
        const plotIndex = user.plots.indexOf(payload.plotId)
        console.log(plotIndex)
        console.log(user.plots)
        user.plots.splice(plotIndex, 1, {'id':payload.plotId, 'done':true})
        console.log(user.plots)
        // state.users[i].plots.splice(plotIndex, 1)
      }
    }
    // plotListも更新
    for (var j in state.plotList){
      if (state.plotList[j].userId == payload.userId && state.plotList[j].plotId == payload.plotId){
        state.plotList.splice(j,1)
      }
    }
  },
  movePlot (state, payload) {
    for (var user of state.users){
      if (user.id == payload.sourceUserId){
        // const plotIndex = user.plots.indexOf(payload.plotId)
        for (var i=0; i<user.plots.length; i++ ){
          if(user.plots[i].id == payload.plotId){
            console.log(user.plots)
            user.plots.splice(i, 1)
            console.log(user.plots)
          }
        }
        // var userPlots = user.plots.filter(plot => plot.id == payload.plotId)
        // user.plots.splice(plotIndex, 1, {'id':payload.plotId, 'done':true})

        // userPlots.splice(0, 1)
      }
    }
    for (user of state.users){
      if (user.id == payload.destinationUserId){
        user.plots.push({'id':payload.plotId, 'done':false})
      }
    }
  },
  clearUserList(state) {
    state.users = []
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}

// function convertRoleJapanese(role) {
//   if (role == 'resistance') {
//     return 'レジスタンス'
//   }else if (role == 'spy') {
//     return 'スパイ'
//   }else {
//     return '不明'
//   }
// }
